import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Modal, Btn } from "@/components/erp/ui";
import { toast } from "sonner";
import { Wand2 } from "lucide-react";

export const RotaSuggest = ({ onApplied }) => {
  const [open, setOpen] = useState(false);
  const [d, setD] = useState(null);
  const [pick, setPick] = useState({});
  const load = async () => {
    try { const { data } = await api.get("/team-calendar/rota-suggest"); setD(data); setPick(Object.fromEntries(data.items.filter((x) => !x.existing && !x.short).map((x) => [`${x.employee_id}|${x.date}`, true]))); setOpen(true); }
    catch (e) { toast.error(e.response?.data?.detail || "Gagal membuat usulan"); }
  };
  const apply = async () => {
    const items = Object.keys(pick).filter((k) => pick[k]).map((k) => { const [employee_id, date] = k.split("|"); return { employee_id, date }; });
    try { const { data } = await api.post("/team-calendar/rota-apply", { items }); toast.success(`${data.applied} jadwal diterapkan`); setOpen(false); onApplied(); }
    catch (e) { toast.error(e.response?.data?.detail || "Gagal menerapkan"); }
  };
  return (
    <>
      <Btn variant="ghost" data-testid="rota-suggest-btn" onClick={load}><Wand2 className="w-4 h-4" /> Usulkan Giliran</Btn>
      <Modal open={open} onClose={() => setOpen(false)} title={d ? `Usulan giliran ${d.saturday} & ${d.sunday}` : "Usulan giliran"}
        footer={<><Btn variant="ghost" onClick={() => setOpen(false)}>Batal</Btn><Btn data-testid="rota-apply-btn" onClick={apply}>Terapkan</Btn></>}>
        <p className="text-xs text-slate-500 mb-3">Dipilih dari yang paling jarang masuk Sabtu–Minggu dalam 90 hari terakhir dan tidak sedang cuti/sakit. Setelah diterapkan tetap bisa diubah manual atau ditukar antar karyawan.</p>
        {d && d.items.length === 0 && <div className="text-sm text-slate-400" data-testid="rota-empty">Tidak ada kategori dengan Sabtu–Minggu bergiliran.</div>}
        <div className="space-y-1.5" data-testid="rota-list">
          {d?.items.map((x, i) => {
            const k = `${x.employee_id}|${x.date}`;
            return (
              <label key={i} className={`flex items-center gap-3 text-sm px-3 py-2 rounded-lg ${x.short ? "bg-rose-50 text-rose-600" : x.existing ? "bg-slate-50 text-slate-500" : "bg-white border border-slate-200"}`} data-testid={`rota-item-${i}`}>
                {!x.existing && !x.short && <input type="checkbox" data-testid={`rota-pick-${i}`} checked={!!pick[k]} onChange={(e) => setPick({ ...pick, [k]: e.target.checked })} />}
                <span className="w-20 sm:w-24 text-xs font-mono shrink-0">{x.date}</span>
                <span className="flex-1 min-w-0"><b>{x.name}</b> <span className="text-[11px] text-slate-400">{x.group} · {x.category}</span>
                  <span className="block text-xs text-slate-500">{x.short ? "" : x.existing ? "sudah dijadwalkan" : `${x.start}–${x.end} · ${x.count}x / 90 hr`}</span></span>
              </label>
            );
          })}
        </div>
      </Modal>
    </>
  );
};
